export const heroContent = {
  badge: '🎉 全新上线 · 限时免费',
  title: '一键发布你的\n专属导航页',
  subtitle: '无需编程基础，轻松创建并在线发布。自定义分类、链接管理、秒级上线，随时随地分享给团队或用户。',
  primaryCta: '免费开始使用',
  primaryCtaHref: '/#pricing',
  secondaryCta: '查看演示',
  secondaryCtaHref: '/#templates',
  stats: [
    { value: '50,000+', label: '已创建导航页' },
    { value: '99.9%', label: '服务可用性' },
    { value: '3分钟', label: '平均创建时间' },
    { value: '200万+', label: '月访问量' },
  ],
};

export const features = [
  {
    icon: 'ri-layout-grid-line',
    title: '自定义分类',
    description: '拖拽式分类管理，自由创建和排列分类，支持无限层级，让链接井井有条。',
  },
  {
    icon: 'ri-link-m',
    title: '链接管理',
    description: '批量添加、编辑和管理链接，支持图标、描述、标签，一键导入浏览器书签。',
  },
  {
    icon: 'ri-rocket-2-line',
    title: '一键部署',
    description: '编辑完成即可发布，无需服务器、域名配置，自动生成专属链接，秒级上线。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '响应式设计',
    description: '所有导航页自动适配手机、平板、电脑，无论在什么设备上都能完美展示。',
  },
  {
    icon: 'ri-palette-line',
    title: '主题定制',
    description: '丰富的主题模板和配色方案，支持自定义背景、字体、布局，打造个性化导航页。',
  },
  {
    icon: 'ri-bar-chart-grouped-line',
    title: '访问统计',
    description: '实时查看导航页访问数据，了解用户点击行为，优化链接布局和内容。',
  },
];

export const howItWorks = [
  {
    step: '01',
    title: '注册账号',
    description: '使用邮箱或手机号注册，30秒完成账号创建，即刻进入工作台。',
  },
  {
    step: '02',
    title: '添加链接',
    description: '创建分类、添加网址链接，设置图标和描述，拖拽排序，所见即所得。',
  },
  {
    step: '03',
    title: '美化页面',
    description: '选择主题模板，调整配色和布局，上传背景图，让导航页与众不同。',
  },
  {
    step: '04',
    title: '一键发布',
    description: '点击发布按钮，生成专属链接，分享给团队或用户，随时随地访问。',
  },
];

export const templates = [
  {
    name: '极简白',
    category: '简约风格',
    imageSeq: 'template-minimal',
    imageQuery: 'Clean%20minimalist%20website%20navigation%20page%20design%20with%20white%20background%2C%20simple%20link%20cards%2C%20elegant%20typography%2C%20soft%20shadows%2C%20modern%20layout%2C%20editorial%20style%2C%20high%20quality%2C%20professional%20look',
  },
  {
    name: '科技蓝',
    category: '科技风格',
    imageSeq: 'template-tech',
    imageQuery: 'Modern%20tech%20style%20navigation%20page%20with%20dark%20gradient%20background%2C%20neon%20link%20cards%2C%20futuristic%20design%2C%20glowing%20elements%2C%20cyberpunk%20aesthetic%2C%20clean%20layout%2C%20professional%20UI',
  },
  {
    name: '暖橙主题',
    category: '活力风格',
    imageSeq: 'template-warm',
    imageQuery: 'Warm%20orange%20themed%20navigation%20page%20design%20with%20soft%20gradient%20background%2C%20rounded%20link%20cards%2C%20friendly%20aesthetic%2C%20modern%20UI%2C%20clean%20layout%2C%20inviting%20color%20palette%2C%20editorial%20quality',
  },
  {
    name: '暗夜模式',
    category: '个性风格',
    imageSeq: 'template-dark',
    imageQuery: 'Dark%20mode%20navigation%20page%20design%20with%20deep%20charcoal%20background%2C%20glass%20morphism%20link%20cards%2C%20modern%20minimalist%20layout%2C%20subtle%20gradients%2C%20professional%20dark%20theme%2C%20editorial%20quality',
  },
];

export const pricingPlans = [
  {
    name: '免费版',
    price: '0',
    unit: '永久免费',
    description: '适合个人用户快速上手',
    popular: false,
    features: [
      '最多创建 3 个导航页',
      '每个导航页 20 个链接',
      '5 种基础主题',
      '基础访问统计',
      '社区支持',
    ],
    cta: '免费开始',
    ctaHref: '#',
  },
  {
    name: '专业版',
    price: '29',
    unit: '/月',
    description: '适合个人创作者和小团队',
    popular: true,
    features: [
      '无限导航页创建',
      '每个导航页无限链接',
      '全部主题模板',
      '自定义域名绑定',
      '高级访问统计',
      'SEO 优化工具',
      '优先客服支持',
    ],
    cta: '立即订阅',
    ctaHref: '#',
  },
  {
    name: '企业版',
    price: '99',
    unit: '/月',
    description: '适合企业和组织使用',
    popular: false,
    features: [
      '专业版全部功能',
      '团队成员协作',
      '权限管理',
      'API 接口',
      '自定义 CSS/JS',
      'SSO 单点登录',
      '专属客户经理',
    ],
    cta: '联系销售',
    ctaHref: '/about#contact',
  },
];

export const faqs = [
  {
    question: '什么是导航页在线发布？',
    answer: '导航页在线发布是一个零代码工具，帮助你快速创建和发布个人或团队的网址导航页面。你只需添加链接、设置分类、选择主题，即可一键生成专属导航页并上线分享。',
  },
  {
    question: '需要编程基础吗？',
    answer: '完全不需要！我们的平台专为非技术用户设计，所有操作都是图形化界面，拖拽即可完成，就像使用文档编辑器一样简单。',
  },
  {
    question: '免费版有什么限制？',
    answer: '免费版支持创建最多 3 个导航页，每个导航页最多添加 20 个链接，可使用 5 种基础主题模板。对于大多数个人用户来说已经足够使用。',
  },
  {
    question: '可以绑定自己的域名吗？',
    answer: '专业版和企业版支持绑定自定义域名。你可以使用自己的域名来展示导航页，让品牌更加专业统一。',
  },
  {
    question: '导航页支持哪些设备？',
    answer: '所有导航页都采用响应式设计，自动适配手机、平板、电脑等不同屏幕尺寸。无论在哪个设备上打开，都能获得良好的浏览体验。',
  },
  {
    question: '数据安全如何保障？',
    answer: '我们使用业界领先的加密技术保护你的数据，定期进行安全审计和备份。所有数据传输采用 HTTPS 加密，确保你的信息安全无虞。',
  },
  {
    question: '可以随时取消订阅吗？',
    answer: '当然可以！你可以随时在账户设置中取消订阅。取消后，在付费周期结束前你仍可使用已付费的功能，已创建的导航页不会被删除。',
  },
];

export const testimonials = [
  {
    name: '张明',
    role: '前端开发团队负责人',
    avatar: 'ZM',
    content: '我们团队用导航页在线发布搭建了内部常用工具导航，新成员入职时直接分享链接就行了，超级方便！分类管理功能让几十个链接也能井井有条。',
  },
  {
    name: '李婷',
    role: '自由设计师',
    avatar: 'LT',
    content: '作为一个设计师，我很在意页面的美观度。这个平台的主题模板都很好看，还能自定义配色，做出来的导航页客户都夸专业。',
  },
  {
    name: '王浩',
    role: '在线教育讲师',
    avatar: 'WH',
    content: '我把课程资料、参考链接、工具网站都整理在一个导航页里，分享给学员超方便。访问统计功能还能看到哪些链接最受欢迎。',
  },
];

export const ctaContent = {
  title: '准备好创建你的专属导航页了吗？',
  subtitle: '免费开始，3分钟即可上线，无需任何技术背景。',
  buttonText: '免费开始使用',
  buttonHref: '/#pricing',
};